import React, { useEffect, useState } from 'react'
import { Col, message, Radio, Row } from 'antd'
import RootState from 'typings/RootState'
import { connect, useDispatch } from 'react-redux'
import { ConfirmWithChild } from 'Components/modal'
import {
  formValidation,
  getBranchMenuSelect,
  getDeliveryStaffMenuSelect,
  getPostcodeMenuSelect,
  getReasonhMenuSelect,
  isAfter,
  isFormError,
  isFormRequired,
  toDateQuery,
} from 'helpers/format'
import moment from 'moment'
import { getTaskLogsAPI, updateToBranchAPI } from 'Store/chaiyo-customer/api'
import { LogReq, SendToBranchReq } from 'Store/chaiyo-customer/types'
import { selectLoginData } from 'Store/user/selector'
import { selectLogsData, selectLogsEvent } from 'Store/chaiyo-customer/selector'
import { AppDateItem, AppInput, AppSelect } from 'Components/form'
import { cloneDeep } from 'lodash'
import {
  selectBranchList,
  selectDeliveryStaffList,
  selectPostcodeList,
  selectReasonList,
} from 'Store/sale-task/selector'
import {
  getBranchListAPI,
  getDeliveyStaffListAPI,
  getPostcodeListAPI,
  getReasonListAPI,
} from 'Store/sale-task/api'
import { BranchReq, DeliveryStaffReq, PostcodeReq, ReasonReq } from 'Store/sale-task/types'
import { SaleTaskStatus } from 'helpers/constanst'
import { SearchOutlined } from '@ant-design/icons'
import { MyTheme } from 'Components/common/Theme'
import styled from 'styled-components'
import { appConfig } from 'config'

type Props = {
  isShow: boolean
  onClose: () => void
  id: number
} & ReduxProps

const SendToBranchModal = (props: Props) => {
  const { isShow, onClose, id, loginData, reasonList, branchList, postcodeList, staffList } = props

  const initForm = {
    branch_customer: '',
    branch_customer_reason: 'TO BRANCH - ลูกค้าพร้อมเข้าสาขา',
    branch_customer_date: '',
    branch_customer_email: '',
    branch_customer_note: '',
    delivery_customer_date: '',
    delivery_customer_email: '',
    delivery_customer_name: '',
    delivery_customer_note: '',
    delivery_customer_postcode: '',
    delivery_customer_reason: 'TO DELIVERY – ลูกค้าพร้อมรับบริการ',
    delivery_customer_staff_id: '',
    status: SaleTaskStatus.TOBRANCH,
    reason: '',
  } as SendToBranchReq

  const toBranchRequireFeild = [
    'branch_customer',
    'branch_customer_reason',
    'branch_customer_date',
    'branch_customer_email',
  ]

  const toDeliveryRequireFeild = [
    'delivery_customer_date',
    'delivery_customer_email',
    'delivery_customer_name',
    'delivery_customer_postcode',
    'delivery_customer_reason',
    'delivery_customer_staff_id',
  ]

  const [formData, setFormData] = useState(cloneDeep(initForm))
  const [formError, setFormError] = useState([] as string[])

  const requireFeild =
    formData.status === SaleTaskStatus.TOBRANCH ? toBranchRequireFeild : toDeliveryRequireFeild
  const taskTypeName = formData.status === SaleTaskStatus.TOBRANCH ? 'สาขา' : ' Delivery '

  const onSendToBranch = (): void => {
    const req: SendToBranchReq = {
      ...formData,
      id,
    }

    if (formData.branch_customer_date) {
      req.branch_customer_date = toDateQuery(formData.branch_customer_date)
    }

    if (formData.delivery_customer_date) {
      req.delivery_customer_date = toDateQuery(formData.delivery_customer_date)
    }

    dispatch(updateToBranchAPI(req, loginData?.access_token || ''))
  }

  const onUpdateData = (val: any, key: string) => {
    if (key === 'mobile' && val.length > 10) return
    setFormData({
      ...formData,
      [key]: val,
    })
  }

  const onGetBranchListAPI = () => {
    const req: BranchReq = {}
    dispatch(getBranchListAPI(req, loginData?.access_token || ''))
  }

  const onGetReasonListAPI = () => {
    const req: ReasonReq = {}
    dispatch(getReasonListAPI(req, loginData?.access_token || ''))
  }

  const onGetPostcodeListAPI = () => {
    const req: PostcodeReq = {}
    dispatch(getPostcodeListAPI(req, loginData?.access_token || ''))
  }

  const onGetStaffByPostcodeAPI = (postcode: string) => {
    const req: DeliveryStaffReq = {
      postcode,
    }
    dispatch(getDeliveyStaffListAPI(req, loginData?.access_token || ''))
  }

  useEffect(() => {
    if (isShow && loginData?.access_token) {
      setFormData({ ...cloneDeep(initForm) })
      onGetBranchListAPI()
      onGetReasonListAPI()
      onGetPostcodeListAPI()
    }
  }, [isShow])

  useEffect(() => {
    if (formError.length > 0) {
      validateForm()
    }
  }, [formData])

  useEffect(() => {
    if (isShow && formData.delivery_customer_postcode) {
      onGetStaffByPostcodeAPI(formData.delivery_customer_postcode)
    }
  }, [formData.delivery_customer_postcode])

  const validateForm = () => {
    const error = formValidation(requireFeild, formData)
    setFormError([...error])
    return error.length > 0 ? false : true
  }

  const isRequired = (name: string) => {
    return isFormRequired(requireFeild, name)
  }

  const isError = (name: string) => {
    return isFormError(formError, name)
  }

  const dispatch = useDispatch()

  const onGetDataList = (): void => {
    const req: LogReq = {
      id: id,
    }
    dispatch(getTaskLogsAPI(req, loginData?.access_token || ''))
  }

  const findEmailByName = (val: string) => {
    const branch = branchList && branchList.find(item => item.name === val)
    const email = []
    if (branch?.email_center) {
      email.push(branch?.email_center)
    }
    if (branch?.email_staff1) {
      email.push(branch?.email_staff1)
    }
    if (branch?.email_staff2) {
      email.push(branch?.email_staff2)
    }
    if (branch?.email_staff3) {
      email.push(branch?.email_staff3)
    }
    return email.join(',')
  }

  const findStaffEmail = (val: string) => {
    const staff = staffList && staffList.find(item => item.staff_id === val)
    const email = []
    if (staff?.email_center) {
      email.push(staff?.email_center)
    }
    if (staff?.email_staff1) {
      email.push(staff?.email_staff1)
    }
    if (staff?.email_staff2) {
      email.push(staff?.email_staff2)
    }
    if (staff?.email_staff3) {
      email.push(staff?.email_staff3)
    }
    return email.join(',')
  }

  const findStaffName = (val: string) => {
    const staff = staffList && staffList.find(item => item.staff_id === val)
    return staff?.name || ''
  }

  const onUpdateBranch = (value: any) => {
    setFormData({
      ...formData,
      branch_customer: value,
      branch_customer_email: findEmailByName(value),
    })
  }

  const onUpdatPostcode = (value: any) => {
    setFormData({
      ...formData,
      delivery_customer_staff_id: '',
      delivery_customer_postcode: value,
    })
  }

  const onUpdatStaff = (value: any) => {
    setFormData({
      ...formData,
      delivery_customer_email: findStaffEmail(value),
      delivery_customer_staff_id: value,
      delivery_customer_name: findStaffName(value),
    })
  }

  const onUpdatStatus = (value: any) => {
    setFormData({
      ...cloneDeep(initForm),
      status: value,
    })
  }

  useEffect(() => {
    if (isShow) {
      onGetDataList()
    }
  }, [isShow, id])

  const getExternalLink = () => {
    return (
      <ExternalLink href={appConfig.externalChaiyoLink} target="_blank" rel="noopener noreferrer">
        &nbsp;
        <SearchOutlined /> ตรวจสอบข้อมูลสาขา, ราคาประเมิน, คำนวนค่างวด
      </ExternalLink>
    )
  }

  const toBranchForm = () => {
    return (
      <Row justify="space-between" gutter={[16, 1]}>
        <Col md={24} xs={24}>
          <AppSelect
            name="branch_customer"
            label="สาขาที่ลูกค้าต้องการเข้าดำเนินการ"
            isRequired={isRequired('branch_customer')}
            isError={isError('branch_customer')}
            value={formData.branch_customer}
            onChange={onUpdateBranch}
            menu={getBranchMenuSelect(branchList)}
          />
        </Col>
        <Col span={24}>
          <AppDateItem
            label="วันที่ลูกค้าต้องการเข้า"
            placeHolder="วันที่ลูกค้าต้องการเข้า"
            isRequired={isRequired('branch_customer_date')}
            isError={isError('branch_customer_date')}
            onChange={(date: string) => onUpdateData(date, 'branch_customer_date')}
            date={formData.branch_customer_date}
            allowClear={false}
            picker="date"
            disableDate={(date: any) => {
              return isAfter(
                moment(date)
                  .subtract(-1, 'days')
                  .startOf('day')
                  .toString(),
              )
            }}
          />
        </Col>
        <Col md={24} xs={24}>
          <AppSelect
            name="branch_customer_reason"
            label="เหตุผล"
            isRequired={isRequired('branch_customer_reason')}
            isError={isError('branch_customer_reason')}
            value={formData.branch_customer_reason}
            onChange={onUpdateData}
            menu={getReasonhMenuSelect(reasonList)}
          />
        </Col>
        <Col span={24}>
          <AppInput
            name="branch_customer_note"
            label="หมายเหตุ"
            isRequired={isRequired('branch_customer_note')}
            isError={isError('branch_customer_note')}
            value={formData.branch_customer_note}
            onChange={onUpdateData}
          />
        </Col>
      </Row>
    )
  }

  const toDeliveryForm = () => {
    return (
      <Row justify="space-between" gutter={[16, 1]}>
        <Col md={24} xs={24}>
          <AppSelect
            name="delivery_customer_postcode"
            label="รหัสไปรษณีย์ ของจุดให้บริการ"
            isRequired={isRequired('delivery_customer_postcode')}
            isError={isError('delivery_customer_postcode')}
            value={formData.delivery_customer_postcode}
            onChange={onUpdatPostcode}
            menu={getPostcodeMenuSelect(postcodeList)}
            allowClear={false}
          />
        </Col>
        <Col md={24} xs={24}>
          <AppSelect
            name="delivery_customer_staff_id"
            label="รายชื่อตัวแทนที่เข้าดำเนินการ"
            isRequired={isRequired('delivery_customer_staff_id')}
            isError={isError('delivery_customer_staff_id')}
            value={formData.delivery_customer_staff_id}
            onChange={onUpdatStaff}
            menu={getDeliveryStaffMenuSelect(staffList)}
            disabled={!formData.delivery_customer_postcode || staffList.length <= 0}
          />
        </Col>
        <Col span={24}>
          <AppDateItem
            label="วันที่นัดหมาย"
            placeHolder="วันที่นัดหมาย"
            isRequired={isRequired('delivery_customer_date')}
            isError={isError('delivery_customer_date')}
            onChange={(date: string) => onUpdateData(date, 'delivery_customer_date')}
            date={formData.delivery_customer_date}
            allowClear={false}
            picker="date"
            disableDate={(date: any) => {
              return isAfter(
                moment(date)
                  .subtract(-1, 'days')
                  .startOf('day')
                  .toString(),
              )
            }}
          />
        </Col>
        <Col md={24} xs={24}>
          <AppSelect
            name="delivery_customer_reason"
            label="เหตุผล"
            isRequired={isRequired('delivery_customer_reason')}
            isError={isError('delivery_customer_reason')}
            value={formData.delivery_customer_reason}
            onChange={onUpdateData}
            menu={getReasonhMenuSelect(reasonList)}
          />
        </Col>
        <Col span={24}>
          <AppInput
            name="delivery_customer_note"
            label="หมายเหตุ"
            isRequired={isRequired('delivery_customer_note')}
            isError={isError('delivery_customer_note')}
            value={formData.delivery_customer_note}
            onChange={onUpdateData}
          />
        </Col>
      </Row>
    )
  }

  const getDailogChild = () => {
    return (
      <Row justify="space-between" gutter={[16, 1]}>
        <Col md={24} xs={24}>
          {getExternalLink()}
        </Col>
        <Col md={24} xs={24}>
          <OptionWrapper>
            <Radio.Group value={formData.status} onChange={e => onUpdatStatus(e.target.value)}>
              <Radio value={SaleTaskStatus.TOBRANCH}>ส่งเคสไปยังสาขา</Radio>
              <Radio value={SaleTaskStatus.TODELIVERY}>ส่งเคสไปยัง Delivery</Radio>
            </Radio.Group>
          </OptionWrapper>
        </Col>
        {formData.status === SaleTaskStatus.TOBRANCH ? (
          <Col md={24} xs={24}>
            {toBranchForm()}
          </Col>
        ) : (
          <Col md={24} xs={24}>
            {toDeliveryForm()}
          </Col>
        )}
      </Row>
    )
  }

  return (
    <ConfirmWithChild
      title={'ยืนยันการส่งเคส'}
      isShow={isShow}
      handleOk={() => {
        if (!validateForm()) {
          message.error('กรุณาระบุข้อมูลให้ครบถ้วน')
          return
        }
        onSendToBranch()
      }}
      handleCancel={() => {
        onClose()
      }}
      child={getDailogChild()}
      confirmBtnTxt={`ยืนยัน`}
    />
  )
}

const ExternalLink = styled.a`
  color: ${(props: { theme: MyTheme }): string => props.theme.colors.primary};
  font-size: ${(props: { theme: MyTheme }): string => props.theme.typography.body3};
`

const OptionWrapper = styled.div`
  background-color: #f0eff5;
  margin: 20px 0;
  padding: 20px 0px;
  font-family: ${(props: { theme: MyTheme }): string => props.theme.fontFamily.bold};

  .ant-radio-wrapper {
    color: ${(props: { theme: MyTheme }): string => props.theme.colors.grey};
  }

  .ant-radio-wrapper-checked {
    color: ${(props: { theme: MyTheme }): string => props.theme.colors.primary};
  }
`

const mapStateToProps = (state: RootState) => {
  return {
    event: selectLogsEvent(state),
    list: selectLogsData(state),
    loginData: selectLoginData(state),
    branchList: selectBranchList(state),
    reasonList: selectReasonList(state),
    postcodeList: selectPostcodeList(state),
    staffList: selectDeliveryStaffList(state),
  }
}

type ReduxProps = ReturnType<typeof mapStateToProps>

export default connect(mapStateToProps)(SendToBranchModal)
